/*
 * @Description: Description
 * @Author: Dai Guo
 * @Date: 2022-02-22 17:14:27
 * @LastEditors: Dai Guo
 * @LastEditTime: 2022-05-05 14:10:56
 */
import { StandardMaterial, Color3, Vector3, MeshBuilder, } from '@babylonjs/core';
import { FRAMEDEPTH, SKIRTINGBOARDCONFIG,
//  SIDE_PLATE_THINKNESS
 } from '../utils/kitchenConfig';
import { LengthType } from '../utils/enum';
class FloorShadow {
    constructor(templateJson, scene, renderEngine) {
        this.alpha = 0.3; // 阴影透明度
        this.color = new Color3(0, 0, 0);
        this.shadowMeshArr = [];
        this.scene = scene;
        this.material = new StandardMaterial('texture', this.scene);
        this.material.diffuseColor = this.color;
        this.material.alpha = this.alpha;
        this.renderEngine = renderEngine;
        this.templateJson = templateJson;
    }
    /**
     * 处理template返回阴影信息
     * @param templateJson templatejson
     * @returns array<shaowInfo> 阴影信息数组
     */
    getShadowFromSkirtingBoard() {
        const infoArr = [];
        // 根据踢脚线创建阴影
        this.renderEngine.skirtingBoard.forEach((item) => {
            var _a;
            if ((_a = item.shadowInfo) === null || _a === void 0 ? void 0 : _a.width) {
                let shadowInfo = null;
                const { type } = item.shadowInfo;
                switch (type) {
                    case 'H':
                    case 'hightFrame':
                        shadowInfo = FloorShadow.getHOrHightFrameShadowInfo(item);
                        break;
                    case 'U':
                    case 'U_S':
                        shadowInfo = FloorShadow.getUShadowInfo(item);
                        break;
                    default:
                        break;
                }
                infoArr.push(shadowInfo);
            }
        });
        return infoArr;
    }
    /**
     * 将调用方法单独写出不在new 的时候调用   冰箱需要单独调用创建阴影
     */
    initShadow() {
        const shadowInfoArr = this.getShadowFromSkirtingBoard();
        shadowInfoArr.forEach((item, index) => {
            this.createShadow(item, index);
        });
    }
    /**
     * 创建地面阴影并将其添加进渲染引擎的mesh数组里面  方便切换的时候重置
     * @param shadowInfo 阴影信息 shadowInfo
     * @param index 阴影名称
     */
    createShadow(shadowInfo, index) {
        const { width, height, position } = shadowInfo;
        const shadowMesh = MeshBuilder.CreateGround(`shadow${index}`, {
            width,
            height,
        }, this.scene);
        shadowMesh.position = position;
        shadowMesh.material = this.material;
        this.shadowMeshArr.push(shadowMesh);
        this.renderEngine.addMesh(shadowMesh);
    }
    /**
     * 设置贴图信息
     * @param material 贴图信息
     */
    setMaterialInfo(material) {
        this.alpha = material.alpha || 0.3;
        this.color = material.color || new Color3(0, 0, 0);
        this.material.diffuseColor = this.color;
        this.material.alpha = this.alpha;
        this.changeShadowMaterial();
    }
    /**
     * 修改阴影的贴图
     */
    changeShadowMaterial() {
        this.shadowMeshArr.forEach((item) => {
            // eslint-disable-next-line no-param-reassign
            item.material = this.material;
        });
    }
    // H或者高柜的阴影位置及大小
    static getHOrHightFrameShadowInfo(item) {
        const { width, lengthType } = item.shadowInfo;
        switch (lengthType) {
            case LengthType.Length1:
                return {
                    width,
                    height: FRAMEDEPTH.BOTTOM,
                    position: new Vector3(item.position.x, 0.005, item.position.z - FRAMEDEPTH.BOTTOM / 2),
                };
            default:
                return {
                    width,
                    height: FRAMEDEPTH.BOTTOM,
                    position: new Vector3(item.position.x, 0.005, item.position.z + FRAMEDEPTH.BOTTOM / 2),
                };
        }
    }
    // U型阴影位置及大小
    static getUShadowInfo(item) {
        const { type, width, lengthType } = item.shadowInfo;
        switch (lengthType) {
            case LengthType.Length1:
                return {
                    width,
                    height: FRAMEDEPTH.BOTTOM,
                    position: new Vector3(item.position.x - SKIRTINGBOARDCONFIG.DEPTH / 2, 0.005, item.position.z - FRAMEDEPTH.BOTTOM / 2),
                };
            case LengthType.Length3:
                return {
                    width,
                    height: type === 'U_S' ? FRAMEDEPTH.USBOTTOM : FRAMEDEPTH.BOTTOM,
                    // 根据l3的柜体深度不同来摆放阴影的z
                    position: new Vector3(item.position.x + SKIRTINGBOARDCONFIG.DEPTH / 2, 0.005, item.position.z + (type === 'U_S' ? FRAMEDEPTH.USBOTTOM : FRAMEDEPTH.BOTTOM) / 2),
                };
            default:
                return {
                    width: FRAMEDEPTH.BOTTOM,
                    height: width + FRAMEDEPTH.BOTTOM + (type === 'U_S' ? FRAMEDEPTH.USBOTTOM : FRAMEDEPTH.BOTTOM),
                    // 踢脚板的中心点是l2的中心 对称的时候才能直接用 l3为短柜体的时候中心点就不对了 需要去向l1方向移动（60-40）/2
                    position: new Vector3(item.position.x + FRAMEDEPTH.BOTTOM / 2 + SKIRTINGBOARDCONFIG.DEPTH, 0.005, type === 'U_S' ? item.position.z - (FRAMEDEPTH.BOTTOM - FRAMEDEPTH.USBOTTOM) / 2
                        : item.position.z),
                };
        }
    }
}
export default FloorShadow;
